import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, EmpenhoStorage, } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmpenhoStorageService extends BaseResourceService<EmpenhoStorage> {

  constructor(
    protected injector: Injector
  ) {
    super(`empenho-storages`, injector);
  }

  public upload(arquivos: any[], orgao: number, empenho: number, descricao?: string, foto?: boolean, visivel_transparencia?: boolean, assinatura?: boolean): Observable<EmpenhoStorage[]> {
    const formData = new FormData();
    for (let arquivo of arquivos) {
      formData.append('files', arquivo);
    }
    if (descricao) {
      formData.append('descricao', descricao);
    }
    if (foto) {
      formData.append('foto', 'S');
    }
    if (visivel_transparencia) {
      formData.append('visivel_transparencia', 'true');
    }

    if (assinatura) {
      formData.append('assinatura', 'true');
    }

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');

    return this.http.post<EmpenhoStorage[]>(`${this.login.cidade.id}/${this.api}/upload/${orgao}/${empenho}`,
      formData, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public downloadArquivo(url: string): Observable<any> {

    const headers = this.httpOptions();
    headers.headers = headers.headers.delete('Content-Type');
    headers['responseType'] = 'blob';

    url = url.replace(/([^:]\/)\/+/g, '$1');
    const encodedUrl = encodeURIComponent(url);

    return this.http.get<any>(`${this.login.cidade.id}/${this.api}/download-arquivo?url=${encodedUrl}`, headers)
      .pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
